import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetMentors } from "../services/AppointmentsService";
import { updateMentors } from "../store/slices/mentorsSlice";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const useMentors = () => {
  const key = "appMentors";

  const getMentors = async () => {
    try {
      // const res = await GetMentors(getParams());
      const res = await GetMentors();
      let data = res?.data?.data;
      const withPhoto = data.filter(
        (m) => m.profile && !m.profile.includes("default.png")
      );
      const withoutPhoto = data.filter(
        (m) => !m.profile || m.profile.includes("default.png")
      );
      const response = [...withPhoto, ...withoutPhoto] || [];

      return response;
    } catch (error) {
      return [];
    }
  };

  // Queries
  const query = useQuery({
    queryKey: [key],
    queryFn: async () => {
      const data = await getMentors();
      return data || [];
    },
  });

  return query;
};
